module.exports = __webpack_public_path__ + "img/welcome-to-real-home.eb720e26.svg";